import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class IotFirmwareScanColoredIcon extends BaseIcon {
  getChildren = () => {
    const color = this.getColor() === 'currentColor' ? '#6568cd' : this.getColor()
    return [
      <g>
          <path fill={ color }
                d="M2,10.82V25.18a3.79,3.79,0,0,0,1.92,3.26l12,7a4.13,4.13,0,0,0,4.16,0l12-7A3.79,3.79,0,0,0,34,25.18V10.82a3.79,3.79,0,0,0-1.92-3.26l-12-7a4.13,4.13,0,0,0-4.16,0l-12,7A3.79,3.79,0,0,0,2,10.82Z"/>
        <path fill={ '#fff' }
              d="M27,19a1,1,0,0,0,0-2H25.5V14.9H27a1,1,0,0,0,0-2H25.5v-.4a2,2,0,0,0-2-2h-.4V9a1,1,0,0,0-2,0v1.5H19V9a1,1,0,0,0-2,0v1.5H14.9V9a1,1,0,0,0-2,0v1.5h-.4a2,2,0,0,0-2,2v.4H9a1,1,0,0,0,0,2h1.5V17H9a1,1,0,0,0,0,2h1.5v2.1H9a1,1,0,0,0,0,2h1.5v.4a1.63,1.63,0,0,0,.07.5,2,2,0,0,1,1.92-1.49v-10h11v11h-11a1,1,0,1,0,0,2h.4V27a1,1,0,0,0,2,0V25.5H17V27a1,1,0,0,0,2,0V25.5h2.1V27a1,1,0,0,0,2,0V25.5h.4a2,2,0,0,0,2-2v-.4H27a1,1,0,0,0,0-2H25.5V19Z"/>
      </g>
    ]
  }
  getViewBox = () => '0 0 36 36'
}
